import { mergeDeep } from 'remeda';
import { type Descendant, Transforms } from 'slate';

import { Editor } from '@@editor/helpers';
import { type InsertElementOptions } from '@@editor/helpers/Editor';
import { type Element } from '@@editor/helpers/Element';
import { createElement } from '@@editor/serialization/UnitySerializer/deserializeNodes';
import { type PluginName } from '@@editor/typings/UnityPlugins';

type InitialOptions = {
    type: PluginName;
    nodeType: Element['type'];
    children?: Descendant[];
};

type Options = { children?: Descendant[] } & InsertElementOptions;

export const createGenerateLayoutBlock =
    (initialOptions: InitialOptions) =>
    (editor: Editor, formData = {}, options: Options = {}) => {
        const { nodeType } = initialOptions;
        const children = options.children ?? initialOptions.children;

        const block = children
            ? createElement(nodeType, formData, children)
            : createElement(nodeType, formData);

        if (options.replace) {
            Transforms.setNodes(editor, { data: block.data }, { at: options.at, merge: mergeDeep });

            return;
        }

        Editor.insertElement(editor, block, options);
    };
